/**
 * Leitura da Central da administracao: `GET /api/admin/overview?from&to`
 * (backend real desde 25/09/2026, src/api/admin.ts), so para `platform_admin`;
 * o servidor agrega `recovery_conversions` por empresa. Nenhum `companyId`
 * viaja: a Central e de TODAS as empresas (o X-Company-Id da equipe e
 * ignorado por esta rota).
 *
 * No backend real o custo ainda NAO e medido: custo e margem chegam `null`,
 * `tariffs: null` e `costsAvailable: false` (types.ts, decisao 7). Nada aqui
 * troca `null` por zero.
 */

import { fetchOrSimulate, rangeQuery, type Envelope } from '../../lib/api';
import type { PeriodRange } from '../../types';
import { simularCentral } from './mock';
import type { PlatformOverview } from './types';

export function fetchPlatformOverview(range: PeriodRange, signal: AbortSignal): Promise<Envelope<PlatformOverview>> {
  return fetchOrSimulate('/api/admin/overview', rangeQuery(range), signal, () => simularCentral(range));
}
